import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-canvas px-5 py-20 md:py-28" data-id="element-105" data-mp="uqj258fdg88g">
      <div className="mx-auto max-w-3xl" data-id="element-106" data-mp="ut59p829inqo">
        <SectionHeading title="Preguntas frecuentes" data-id="element-107" data-mp="70f21b1e6qm7" />
        <ul className="mt-12 space-y-3" data-id="element-108" data-mp="731jq3hzymi5">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`rounded-xl border bg-surface transition-colors duration-200 ${isOpen ? 'border-accent/60' : 'border-line'}`} data-id="element-109" data-mp="gz4jx3tagb2g" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 rounded-xl px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-110" data-mp="byqapifyav2u">
                  <span className="text-lg font-semibold text-ink md:text-xl" data-id="element-111" data-mp="hu8zb9aof6ni">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-112" data-mp="msk9jl4vvj69" />
                </button>
                <AnimatePresence initial={false} data-id="element-113" data-mp="vtifi8yvu0rh">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-114" data-mp="vspelomlu5h9">
                      <p className="px-6 pb-6 text-lg leading-relaxed text-muted" data-id="element-115" data-mp="cwqxs3yzntpj">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}